module.exports = __webpack_public_path__ + "img/timeline-feedback-graphic.f05d4bbb.png";